module.exports = __webpack_public_path__ + "media/images/front/ogp-8e86a66ef771a0b590542667058922eb.png";